import React from 'react';
import BaseContextMenu from './BaseContextMenu';
import { ReactComponent as Checked } from 'img/icon-checked.svg';
import './SimpleContextMenu.scss';

export interface SimpleContextMenuItem {
  label: string;
  onClick: () => void;
  icon?: React.ReactElement;
  isChecked?: boolean;
}

export interface ExtraMenuAction {
  title?: string;
  label: string;
  onClick: () => void;
  additionalClass?: string;
}

export interface SimpleContextMenuProps {
  items: SimpleContextMenuItem[];
  ExtraActions?: ExtraMenuAction[];
  onClose: () => void;
  checkbox?: Boolean;
}

const SimpleContextMenu = ({
  items,
  ExtraActions,
  onClose,
  checkbox = false,
}: SimpleContextMenuProps) => {
  return (
    <BaseContextMenu onClose={onClose}>
      {items.map((item, index) => (
        <div
          key={index}
          className="simple-context-menu-item"
          onClick={() => {
            item.onClick();
          }}
        >
          {item.icon && (
            <span className="simple-context-menu-item-icon">{item.icon}</span>
          )}
          {checkbox && (
            <span
              className="simple-context-menu-item-checked"
              style={{ opacity: Number(item.isChecked) }}
            >
              {item.isChecked !== undefined && <Checked />}
            </span>
          )}

          <span className="simple-context-menu-item-label">{item.label}</span>
        </div>
      ))}
      {ExtraActions && (
        <div className="simple-context-menu-extra">
          {ExtraActions?.map((Extra, index) => (
            <div
              key={index}
              className={`simple-context-menu-extra-item ${Extra.additionalClass}`}
              onClick={() => {
                Extra.onClick();
              }}
            >
              {Extra.label}
            </div>
          ))}
        </div>
      )}
    </BaseContextMenu>
  );
};

export default SimpleContextMenu;
